import { LOCAL_LANDING_BENEFITS } from "../../constants/localData";
import {
  BenefitContent,
  BenefitIcon,
  BenefitItem,
  BenefitSeparator,
  BenefitTitle,
  LandingBenefitsContainer,
} from "./LandingBenefits.style";

type LandingBenefitsProps = {
  benefitsDataList?: {
    icon: string;
    title: string;
    subtitle?: string;
  }[];
};
const LandingBenefits = ({ benefitsDataList }: LandingBenefitsProps) => {
  const benefitsData = benefitsDataList || LOCAL_LANDING_BENEFITS;
  if (!benefitsData) return null;
  return (
    <LandingBenefitsContainer>
      {benefitsData.map((item, index) => (
        <>
          <BenefitItem key={index}>
            <BenefitIcon src={item.icon} alt={item.title} />
            <BenefitContent>
              <BenefitTitle>{item.title}</BenefitTitle>
              {/* <BenefitSubtitle>{item.subtitle}</BenefitSubtitle> */}
            </BenefitContent>
          </BenefitItem>
          {index !== benefitsData.length - 1 && <BenefitSeparator />}
        </>
      ))}
    </LandingBenefitsContainer>
  );
};

export default LandingBenefits;
